module.exports = __webpack_public_path__ + "static/media/img_02.625f274f.jpg";